import React from 'react';
export const CookiePolicy = () => {
  return <div className="pt-20" data-id="element-2290">
      <section className="py-16 bg-secondary/5" data-id="element-2291">
        <div className="container mx-auto px-4" data-id="element-2292">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2293">
            Cookie Policy
          </h1>
          <p className="text-center text-secondary" data-id="element-2294">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-2295">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-2296">
          <div className="prose prose-lg max-w-none" data-id="element-2297">
            <p data-id="element-2298">
              The Networking Salon ("we," "our," or "us") uses cookies and
              similar technologies on our website to improve your browsing
              experience, analyze traffic, and provide relevant content. This
              Cookie Policy explains what cookies are, how we use them, and your
              choices.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2299">
              1. What Are Cookies?
            </h2>
            <p data-id="element-2300">
              Cookies are small text files stored on your device when you visit
              a website. They help websites recognize your device, remember
              preferences, and improve functionality.
            </p>
            <p data-id="element-2301">Cookies may be:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2302">
              <li data-id="element-2303">
                <strong data-id="element-2304">Session Cookies:</strong> Temporary, deleted when you
                close your browser.
              </li>
              <li data-id="element-2305">
                <strong data-id="element-2306">Persistent Cookies:</strong> Stay on your device until
                deleted or they expire.
              </li>
              <li data-id="element-2307">
                <strong data-id="element-2308">First-Party Cookies:</strong> Placed by our website.
              </li>
              <li data-id="element-2309">
                <strong data-id="element-2310">Third-Party Cookies:</strong> Placed by external
                services (e.g., Google Analytics, social media).
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2311">
              2. How We Use Cookies
            </h2>
            <p data-id="element-2312">We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2313">
              <li data-id="element-2314">
                <strong data-id="element-2315">Essential:</strong> Ensure our website functions
                properly (e.g., navigation, forms).
              </li>
              <li data-id="element-2316">
                <strong data-id="element-2317">Analytics:</strong> Understand how visitors use our site
                to improve performance (e.g., Google Analytics).
              </li>
              <li data-id="element-2318">
                <strong data-id="element-2319">Preferences:</strong> Remember your settings (e.g.,
                language, event selections).
              </li>
              <li data-id="element-2320">
                <strong data-id="element-2321">Marketing:</strong> Deliver relevant promotions and
                measure the effectiveness of campaigns.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2322">
              3. Third-Party Cookies
            </h2>
            <p data-id="element-2323">We may use trusted third-party services, including:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2324">
              <li data-id="element-2325">Google Analytics for insights on website usage.</li>
              <li data-id="element-2326">
                Social Media Plugins (e.g., LinkedIn, Instagram) for sharing and
                engagement.
              </li>
            </ul>
            <p data-id="element-2327">
              These providers may set cookies according to their own privacy
              policies.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2328">4. Your Choices</h2>
            <p data-id="element-2329">You can manage or disable cookies by:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-2330">
              <li data-id="element-2331">
                Adjusting your browser settings to block or delete cookies.
              </li>
              <li data-id="element-2332">
                Opting out of analytics/advertising cookies where applicable.
              </li>
            </ul>
            <p data-id="element-2333">
              Please note: disabling cookies may affect website functionality.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2334">
              5. Updates to This Policy
            </h2>
            <p data-id="element-2335">
              We may update this Cookie Policy to reflect changes in technology,
              legal requirements, or our practices. Updates will be posted on
              this page with a new "last updated" date.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-2336">6. Contact Us</h2>
            <p data-id="element-2337">For questions about our use of cookies, please contact us:</p>
            <p data-id="element-2338">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2339">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};